export const IconProfile: React.FC = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="20" viewBox="0 0 18 20" fill="none">
      <path className="icon" d="M17 19V17C17 15.9391 16.5786 14.9217 15.8284 14.1716C15.0783 13.4214 14.0609 13 13 13H5C3.93913 13 2.92172 13.4214 2.17157 14.1716C1.42143 14.9217 1 15.9391 1 17V19M13 5C13 7.20914 11.2091 9 9 9C6.79086 9 5 7.20914 5 5C5 2.79086 6.79086 1 9 1C11.2091 1 13 2.79086 13 5Z" stroke="#24282C" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

export const IconChange: React.FC = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
      <path className="icon" d="M1 3.5H10M8 1L10.5 3.5L8 6M11 8.5H2M4 6L1.5 8.5L4 11" stroke="#24282C" strokeWidth="1.2" />
    </svg>
  );
};

export const IconLogout: React.FC = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">
      <path d="M4.99969 1.25V4.86938" stroke="#EA3A3D" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M7.1819 1.54667C7.9046 2.03947 8.45596 2.76375 8.7538 3.61156C9.05164 4.45938 9.08002 5.38533 8.83471 6.25142C8.5894 7.11751 8.08353 7.87736 7.39249 8.41772C6.70146 8.95808 5.86227 9.25001 4.99999 9.25001C4.13771 9.25001 3.29852 8.95807 2.60749 8.41771C1.91646 7.87735 1.41059 7.1175 1.16529 6.25141C0.919975 5.38532 0.948359 4.45936 1.2462 3.61154C1.54405 2.76373 2.09541 2.03945 2.81811 1.54666" stroke="#EA3A3D" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

export const IconFullScreen: React.FC = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path d="M8 3H5C4.46957 3 3.96086 3.21071 3.58579 3.58579C3.21071 3.96086 3 4.46957 3 5V8M21 8V5C21 4.46957 20.7893 3.96086 20.4142 3.58579C20.0391 3.21071 19.5304 3 19 3H16M16 21H19C19.5304 21 20.0391 20.7893 20.4142 20.4142C20.7893 20.0391 21 19.5304 21 19V16M3 16V19C3 19.5304 3.21071 20.0391 3.58579 20.4142C3.96086 20.7893 4.46957 21 5 21H8" stroke="#24282C" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};
export const IconDate: React.FC = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="20" viewBox="0 0 18 20" fill="none">
      <path d="M12.3333 1.66663V4.99996M5.66667 1.66663V4.99996M1.5 8.33329H16.5M3.16667 3.33329H14.8333C15.7538 3.33329 16.5 4.07948 16.5 4.99996V16.6666C16.5 17.5871 15.7538 18.3333 14.8333 18.3333H3.16667C2.24619 18.3333 1.5 17.5871 1.5 16.6666V4.99996C1.5 4.07948 2.24619 3.33329 3.16667 3.33329Z" stroke="#4F5356" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};
export const IconArrowRight: React.FC = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};
export const IconClose: React.FC = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8" fill="none">
      <path d="M7 1L1 7M1 1L7 7" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};
export const IconDelete: React.FC = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="22" viewBox="0 0 20 22" fill="none">
      <path d="M1 5H3M3 5H19M3 5V19C3 19.5304 3.21071 20.0391 3.58579 20.4142C3.96086 20.7893 4.46957 21 5 21H15C15.5304 21 16.0391 20.7893 16.4142 20.4142C16.7893 20.0391 17 19.5304 17 19V5H3ZM6 5V3C6 2.46957 6.21071 1.96086 6.58579 1.58579C6.96086 1.21071 7.46957 1 8 1H12C12.5304 1 13.0391 1.21071 13.4142 1.58579C13.7893 1.96086 14 2.46957 14 3V5M8 10V16M12 10V16" stroke="#EA3A3D" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};
export const IconExport: React.FC = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
      <path d="M16.875 1.125H5.625C5.00368 1.125 4.5 1.62868 4.5 2.25V15.75C4.5 16.3713 5.00368 16.875 5.625 16.875H16.875C17.4963 16.875 18 16.3713 18 15.75V2.25C18 1.62868 17.4963 1.125 16.875 1.125Z" fill="#2FB776" />
      <path d="M4.5 12.9375H18V15.75C18 16.3713 17.4963 16.875 16.875 16.875H5.625C5.00368 16.875 4.5 16.3713 4.5 15.75V12.9375Z" fill="url(#paint0_linear_1723_27246)" />
      <path d="M18 9H11.25V12.9375H18V9Z" fill="#229C5B" />
      <path d="M18 5.0625H11.25V9H18V5.0625Z" fill="#27AE68" />
      <path d="M4.5 2.25C4.5 1.62868 5.00368 1.125 5.625 1.125H11.25V5.0625H4.5V2.25Z" fill="#1D854F" />
      <path d="M11.25 5.0625H4.5V9H11.25V5.0625Z" fill="#197B43" />
      <path d="M11.25 9H4.5V12.9375H11.25V9Z" fill="#1B5B38" />
      <path d="M4.5 6.75C4.5 5.81799 5.25552 5.0625 6.1875 5.0625H9.5625C10.4945 5.0625 11.25 5.81799 11.25 6.75V13.5C11.25 14.432 10.4945 15.1875 9.5625 15.1875H4.5V6.75Z" fill="black" fillOpacity="0.3" />
      <path d="M9 3.9375H1.125C0.50368 3.9375 0 4.44118 0 5.0625V12.9375C0 13.5588 0.50368 14.0625 1.125 14.0625H9C9.62132 14.0625 10.125 13.5588 10.125 12.9375V5.0625C10.125 4.44118 9.62132 3.9375 9 3.9375Z" fill="url(#paint1_linear_1723_27246)" />
      <path d="M7.3125 11.8125L5.72743 8.94375L7.24292 6.1875H6.00581L5.07023 7.94734L4.15013 6.1875H2.87436L4.39755 8.94375L2.8125 11.8125H4.04961L5.04704 9.94821L6.03675 11.8125H7.3125Z" fill="white" />
      <defs>
        <linearGradient id="paint0_linear_1723_27246" x1="4.5" y1="14.9063" x2="18" y2="14.9063" gradientUnits="userSpaceOnUse">
          <stop stopColor="#163C27" />
          <stop offset="1" stopColor="#2A6043" />
        </linearGradient>
        <linearGradient id="paint1_linear_1723_27246" x1="0" y1="9" x2="10.125" y2="9" gradientUnits="userSpaceOnUse">
          <stop stopColor="#185A30" />
          <stop offset="1" stopColor="#176F3D" />
        </linearGradient>
      </defs>
    </svg>
  );
};
export const IconPublish: React.FC = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
      <path d="M21 10.0799V10.9999C20.9988 13.1563 20.3005 15.2545 19.0093 16.9817C17.7182 18.7088 15.9033 19.9723 13.8354 20.5838C11.7674 21.1952 9.55726 21.1218 7.53447 20.3744C5.51168 19.6271 3.78465 18.246 2.61096 16.4369C1.43727 14.6279 0.879791 12.4879 1.02168 10.3362C1.16356 8.18443 1.99721 6.13619 3.39828 4.49694C4.79935 2.85768 6.69279 1.71525 8.79619 1.24001C10.8996 0.764774 13.1003 0.982201 15.07 1.85986M21 2.99986L11 13.0099L8.00001 10.0099" stroke="white" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};
export const IconSearch: React.FC = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
      <path d="M16.5 16.5L12.875 12.875M14.8333 8.16667C14.8333 11.8486 11.8486 14.8333 8.16667 14.8333C4.48477 14.8333 1.5 11.8486 1.5 8.16667C1.5 4.48477 4.48477 1.5 8.16667 1.5C11.8486 1.5 14.8333 4.48477 14.8333 8.16667Z" stroke="#4F5356" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};
export const IconCopy: React.FC = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
      <path d="M2.80012 8.8H2.20012C1.88186 8.8 1.57664 8.67357 1.35159 8.44853C1.12655 8.22348 1.00012 7.91826 1.00012 7.6V2.2C1.00012 1.88174 1.12655 1.57652 1.35159 1.35147C1.57664 1.12643 1.88186 1 2.20012 1H7.60012C7.91838 1 8.22361 1.12643 8.44865 1.35147C8.67369 1.57652 8.80012 1.88174 8.80012 2.2V2.8M6.40012 5.2H11.8001C12.4629 5.2 13.0001 5.73726 13.0001 6.4V11.8C13.0001 12.4627 12.4629 13 11.8001 13H6.40012C5.73738 13 5.20012 12.4627 5.20012 11.8V6.4C5.20012 5.73726 5.73738 5.2 6.40012 5.2Z" stroke="#1BB4E2" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};
export const IconInfo: React.FC = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <g clipPath="url(#clip0_902_54533)">
        <path d="M8.00016 10.6663V7.99967M8.00016 5.33301H8.00683M14.6668 7.99967C14.6668 11.6816 11.6821 14.6663 8.00016 14.6663C4.31826 14.6663 1.3335 11.6816 1.3335 7.99967C1.3335 4.31778 4.31826 1.33301 8.00016 1.33301C11.6821 1.33301 14.6668 4.31778 14.6668 7.99967Z" stroke="#7B7E80" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
      </g>
      <defs>
        <clipPath id="clip0_902_54533">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
export const IconPlus: React.FC = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="13" viewBox="0 0 14 13" fill="none">
      <path d="M7 1.25V11.75M1.75 6.5H12.25" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};
export const IconAngleRIght: React.FC = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="8" height="12" viewBox="0 0 8 12" fill="none">
      <path d="M1.75 10.5L6.25 6L1.75 1.5" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};
export const IconReset: React.FC = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
      <path d="M1 1.77614V6.44404M1 6.44404H5.09091M1 6.44404L4.16364 3.05203C4.89642 2.21548 5.80298 1.60437 6.79873 1.27572C7.79449 0.947078 8.84697 0.91161 9.85799 1.17263C10.869 1.43365 11.8056 1.98264 12.5804 2.76839C13.3551 3.55414 13.9428 4.55104 14.2886 5.66605M16 14.2239V9.55596M16 9.55596H11.9091M16 9.55596L12.8364 12.948C12.1036 13.7845 11.197 14.3956 10.2013 14.7243C9.20551 15.0529 8.15303 15.0884 7.14201 14.8274C6.131 14.5664 5.19441 14.0174 4.41964 13.2316C3.64486 12.4459 3.05716 11.449 2.71136 10.3339" stroke="#EA3A3D" strokeWidth="1.55596" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};


export const ReportIcon: React.FC = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
      <path d="M10.5 1.5H4.5C4.10218 1.5 3.72064 1.65804 3.43934 1.93934C3.15804 2.22064 3 2.60218 3 3V15C3 15.3978 3.15804 15.7794 3.43934 16.0607C3.72064 16.342 4.10218 16.5 4.5 16.5H13.5C13.8978 16.5 14.2794 16.342 14.5607 16.0607C14.842 15.7794 15 15.3978 15 15V6M10.5 1.5L15 6M10.5 1.5V6H15M12 9.75H6M12 12.75H6M7.5 6.75H6" stroke="#24282C" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};
export const IconBack: React.FC = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
      <path d="M12.8337 7.0013H1.16699M1.16699 7.0013L7.00033 12.8346M1.16699 7.0013L7.00033 1.16797" stroke="#24282C" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};
export const IconEdit: React.FC = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
      <path d="M9.16699 3.33417H3.33366C2.89163 3.33417 2.46771 3.50977 2.15515 3.82233C1.84259 4.13489 1.66699 4.55881 1.66699 5.00084V16.6675C1.66699 17.1095 1.84259 17.5335 2.15515 17.846C2.46771 18.1586 2.89163 18.3342 3.33366 18.3342H15.0003C15.4424 18.3342 15.8663 18.1586 16.1788 17.846C16.4914 17.5335 16.667 17.1095 16.667 16.6675V10.8342M15.417 2.08417C15.7485 1.75265 16.1982 1.56641 16.667 1.56641C17.1358 1.56641 17.5855 1.75265 17.917 2.08417C18.2485 2.41569 18.4348 2.86533 18.4348 3.33417C18.4348 3.80301 18.2485 4.25265 17.917 4.58417L10.0003 12.5008L6.66699 13.3342L7.50033 10.0008L15.417 2.08417Z" stroke="#24282C" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};
export const IconInfoRed: React.FC = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
      <path d="M9 12V9M9 6H9.0075M16.5 9C16.5 13.1421 13.1421 16.5 9 16.5C4.85786 16.5 1.5 13.1421 1.5 9C1.5 4.85786 4.85786 1.5 9 1.5C13.1421 1.5 16.5 4.85786 16.5 9Z" stroke="#D86840" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};
export const IconUpload: React.FC = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none">
      <path d="M1.7002 10.3117V11.8305C1.7002 12.2333 1.86021 12.6196 2.14503 12.9044C2.42985 13.1892 2.81615 13.3492 3.21895 13.3492H12.3314C12.7342 13.3492 13.1205 13.1892 13.4054 12.9044C13.6902 12.6196 13.8502 12.2333 13.8502 11.8305V10.3117M4.7377 4.23672L7.7752 1.19922M7.7752 1.19922L10.8127 4.23672M7.7752 1.19922V10.3117" stroke="#4F5356" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};
export const IconDownload: React.FC = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="15" viewBox="0 0 16 15" fill="none">
      <path d="M1.25 10.875V12.5625C1.25 13.0101 1.42779 13.4393 1.74426 13.7557C2.06072 14.0722 2.48995 14.25 2.9375 14.25H13.0625C13.5101 14.25 13.9393 14.0722 14.2557 13.7557C14.5722 13.4393 14.75 13.0101 14.75 12.5625V10.875M11.375 7.5L8 10.875M8 10.875L4.625 7.5M8 10.875V0.75" stroke="#4F5356" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};
export const IconLargeUpload: React.FC = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="45" height="30" viewBox="0 0 45 30" fill="none">
      <path d="M35.975 11.4054C34.7283 5.08036 29.1733 0.332031 22.5 0.332031C17.2017 0.332031 12.6 3.3387 10.3083 7.7387C4.79 8.32536 0.5 13.0004 0.5 18.6654C0.5 24.7337 5.43167 29.6654 11.5 29.6654H35.3333C40.3933 29.6654 44.5 25.5587 44.5 20.4987C44.5 15.6587 40.7417 11.7354 35.975 11.4054ZM35.3333 25.9987H11.5C7.44833 25.9987 4.16667 22.717 4.16667 18.6654C4.16667 14.907 6.97167 11.772 10.6933 11.387L12.655 11.1854L13.5717 9.4437C15.3133 6.0887 18.7233 3.9987 22.5 3.9987C27.3033 3.9987 31.4467 7.4087 32.3817 12.1204L32.9317 14.8704L35.7367 15.072C38.5967 15.2554 40.8333 17.657 40.8333 20.4987C40.8333 23.5237 38.3583 25.9987 35.3333 25.9987ZM15.1667 16.832H19.8417V22.332H25.1583V16.832H29.8333L22.5 9.4987L15.1667 16.832Z" fill="#8B96A5" />
    </svg>
  );
};
export const IconView: React.FC = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="100" height="100" viewBox="0 0 100 100" id="view">
      <g id="_x37_7_Essential_Icons">
        <path id="View" d="M50 34c-8.8 0-16 7.2-16 16s7.2 16 16 16 16-7.2 16-16-7.2-16-16-16zm0 28c-6.6 0-12-5.4-12-12s5.4-12 12-12 12 5.4 12 12-5.4 12-12 12zm44.4-13.4l-8.6-8.7C76.3 30.3 63.6 25 50 25s-26.3 5.3-35.8 14.9l-8.6 8.7c-.8.8-.8 2 0 2.8l8.6 8.7C23.7 69.7 36.4 75 50 75s26.3-5.3 35.8-14.9l8.6-8.7c.8-.8.8-2 0-2.8zM83 57.3C74.2 66.1 62.5 71 50 71s-24.2-4.9-33-13.7L9.8 50l7.2-7.3C25.8 33.9 37.5 29 50 29s24.2 4.9 33 13.7l7.2 7.3-7.2 7.3z"/>
      </g>
      <g id="Info">
        <path id="BORDER" fill="#00F" d="M944-790V894H-840V-790H944m8-8H-848V902H952V-798z"/>
      </g>
    </svg>
  );
};
export const IconDataMap: React.FC = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="#00F" width="800px" height="800px" viewBox="0 0 52 52" data-name="Layer 1"><path d="M44.5,21a5.5,5.5,0,1,1-4.9,8h-.91c-5.39.06-7.29,1.7-10.31,7.34l-.17.33-.2.38c-1.8,3.37-2.82,4.9-4.66,6.52C20.76,45.84,17.42,47,13,47h-.6a5.5,5.5,0,1,1,0-5h.91c5.49-.06,7.36-1.76,10.48-7.67h0L24,34a27.18,27.18,0,0,1,3.11-5H12.4a5.5,5.5,0,1,1,0-5H39.6a5.53,5.53,0,0,1,4.68-3Zm0-19a5.5,5.5,0,1,1-4.9,8H12.4a5.5,5.5,0,1,1,0-5H39.6A5.5,5.5,0,0,1,44.5,2Z"/></svg>
  );
};